// extracted by mini-css-extract-plugin
export default {"smIcon":"styles_smIcon__Sxf+q","mdIcon":"styles_mdIcon__FlePn","lgIcon":"styles_lgIcon__kh0g4","xlIcon":"styles_xlIcon__8KCbE"};